export function underlineMarkSpec() {
    return {
        underline: {
            parseDOM: [
                { tag: "u" },
                {
                    style: "text-decoration",
                    getAttrs: (value) => (value === "underline" ? {} : false),
                },
            ],
            toDOM: () => ["u", {}, 0],
        },
    };
}
